<template lang="pug">
.stock-detail-layout(v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)")

    .card.stock-info.box
        .company-info(v-loading="companyLoading" element-loading-background="rgba(0, 0, 0, 0.8)" :class="moreInfo && 'more'")
            h3
                span
                    span.mr20(v-if="company") {{company.secname}} | {{company.seccode}}
                    span.mr20(v-else) 公司概况

                    a(@click="moreInfoHandler" href="javascript:;")
                        i.el-icon-minus(v-if="moreInfo") 收起
                        i.el-icon-plus(v-else) 展开
                span
                    el-button(href="javascript:;" @click="follow" v-loading="followLoading" type="mini")
                        span(v-if="followed")
                            i.el-icon-star-on
                            | &nbsp;已关注
                        span(v-else)
                            i.el-icon-star-off
                            | 关注

                    el-button(href="javascript:;" @click="openDialog"  type="mini") 关联兴趣区
                    el-button(href="javascript:;" @click="createAoi"  type="mini") 新建兴趣区
            .companies(v-if="company")
                .company(v-if="stock && stock.latest_price")
                    span.key 股票价格：
                    span.value &yen; {{stock.latest_price}} ({{ ((stock.latest_price - stock.close_price) / stock.close_price * 100).toFixed(2) }}%)
                    a.stock-refresh.el-icon-refresh(@click="getStock" href="javascript:;" :class="stockLoading && 'stock-loading' || ''")
                    span.value &nbsp; 更新时间：{{stock.date}} {{stock.time}}
                .company(v-for="k in CompanyList" :key="k" v-if="company[k]")
                    span.key {{CompanyDict[k] || k}}:
                    span.value {{company[k]}}
            .empty(v-else)
                el-empty
            .more-button
                el-button(@click="moreInfoHandler") {{moreInfo ? '- 收起' : '+ 查看更多'}}
        .sticky(ref="sticky")
            .candlestick(:class="chartFixed && 'on'")
                CandleStick.mb20(v-show="dailyData || dailyLoading" :products="products" :dailydata="dailyData" @markPointClick="markPointClickHandler" v-loading="dailyLoading" element-loading-background="rgba(0, 0, 0, 0.8)")
                //- .tc
                //-     el-button(v-if="chartFixed" @click="chartFixed = false" size="mini") 取消浮动
            .products
                .products-container(v-for="(productList, i) in products" :key="i")
                    .products-title {{productList.name}}
                    dl(v-for="(item, index) in productList.items" :key="item.id")
                        dd
                            el-image.img(:src="item.image" :data-aoi-id="productList.id" :ref="`image-${item.date_str}-${i}`" :preview-src-list="productList.items.map(product => product.image)")
                        dt.date-str {{item.date_str}}

    .card.box.timeline(v-loading="disclosureLoading" element-loading-background="rgba(0, 0, 0, 0.8)" ref="timeline")
        h3 最新动态
        el-timeline(v-if="disclosureList" )
            el-timeline-item(v-for="item in disclosureList" :key="item.value" :data-datetime="item.datetime" :timestamp="new Date(item.datetime * 1000).toLocaleString()" placement="top")
                h4(v-if="item.type == 'financial_report'") {{item.title}}
                h4.pointer(v-else="item.type == 'disclosure'" @click="disclosureHandler(item.target_info)") {{item.title}}
                FinancialReport(v-if="item.type == 'financial_report'" :info="item.target_info")
        .empty(v-else)
            el-empty
    el-dialog(title="关联兴趣区" :visible.sync="dialogShow" v-loading="aoiLoading" element-loading-background="rgba(0, 0, 0, 0.8)")
        el-select.aois(filterable :value="aoiId || ''" placeholder="请选择" @change="aoiChange" size="small")
            el-option(v-for="item in aoiList"
                :key="item.id"
                :label="item.name || item.id"
                :value="item.id")
        .dialog-footer(slot="footer")
            el-button(@click="dialogShow = false") 取 消
            el-button(type="primary" @click="confirm") 确 定
    el-dialog(title="查看兴趣区" :visible="aoi && product && true" @close="(aoi = null) && (product = null)")
        .map
            POLYGON_MAP(:height="600" :aoi="aoi" :product="product")

</template>

<script>
import storeMixin from '../store/mixin';
import CandleStick from '../components/candlestick.vue';
import FinancialReport from '../components/financial-report.vue';
import CompanyDict from '../common/company-dict.json';
import CompanyList from '../common/company-info-list.json';
import DownloadDisclosure from '../utils/download-disclosure';
import POLYGON_MAP from '../components/map/polygon.vue';
import { setTimeout } from 'timers';

export default {
    mixins: [storeMixin],
    components: { CandleStick, FinancialReport, POLYGON_MAP },
    name: 'Stock',
    props: {
        code: String,
    },
    data() {
        return {
            dialogShow: false,
            loading: false,
            companyLoading: false,
            disclosureLoading: false,
            dailyLoading: false,
            company: null,
            disclosureList: null,
            dailyData: null,
            aoiList: null,
            aoiId: null,
            aoiLoading: false,
            followLoading: false,
            followed: false,
            stock: null,
            stockLoading: false,
            realatedAoiList: null,
            products: null,
            moreInfo: false,
            chartFixed: false,
            // 地图展示模块
            aoi: null,
            product: null,
            stickyData: {},
            fixRect: null,
        };
    },
    computed: {
        CompanyDict() {
            return CompanyDict;
        },
        CompanyList() {
            return CompanyList;
        },
    },
    created() {
        this.getCompany();
        this.getDisclosure();
        this.getDaily();
        this.getStock();
        this.getRelatedAois();
    },
    mounted() {
        this.initScorllRect();
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollHandler);
    },
    methods: {
        moreInfoHandler() {
            this.moreInfo = !this.moreInfo;
            this.$nextTick(this.initScorllRect);
        },
        initScorllRect() {
            const ele = this.$refs.sticky;
            this.stickyData.initRect = ele.getBoundingClientRect();
            this.stickyData.initScrollY = window.scrollY;
            this.stickyData.scrollY = window.scrollY;
            this.stickyData.innerHeight = window.innerHeight;
            window.addEventListener('scroll', this.scrollHandler);
        },
        scrollHandler() {
            const ele = this.$refs.sticky;
            if (!ele) return;
            if (!this.fixRect) {
                this.fixRect = ele.getBoundingClientRect();
                this.stickyData.initRect.height = this.fixRect.height;
            }
            if (
                this.stickyData.initRect.height < this.stickyData.innerHeight &&
                window.scrollY >=
                    this.stickyData.initRect.top + this.stickyData.initScrollY
            ) {
                ele.setAttribute(
                    'style',
                    `position:fixed; top:40px;width:${this.stickyData.initRect.width}px`
                );
                this.stickyData.scrollY = window.scrollY;
                return;
            }

            if (
                window.scrollY <
                this.stickyData.initRect.top + this.stickyData.initScrollY
            ) {
                ele.removeAttribute('style');
                this.stickyData.scrollY = window.scrollY;
                return;
            }
            const boundingRect = ele.getBoundingClientRect();
            if (window.scrollY > this.stickyData.scrollY) {
                console.log(ele.style.position);
                if (
                    window.scrollY + this.stickyData.innerHeight >=
                    boundingRect.top + boundingRect.height + window.scrollY
                ) {
                    ele.setAttribute(
                        'style',
                        `position:fixed; bottom:0px;width:${this.stickyData.initRect.width}px`
                    );
                } else if (ele.style.position == 'fixed') {
                    ele.setAttribute(
                        'style',
                        `position:absolute; top:${window.scrollY +
                            boundingRect.top}px; width:${
                            this.stickyData.initRect.width
                        }px`
                    );
                }
                this.stickyData.scrollY = window.scrollY;
                return;
            }
            if (window.scrollY < this.stickyData.scrollY) {
                if (boundingRect.top >= 0) {
                    ele.setAttribute(
                        'style',
                        `position:fixed; top:0px; width:${this.stickyData.initRect.width}px`
                    );
                } else if (ele.style.position == 'fixed') {
                    ele.setAttribute(
                        'style',
                        `position:absolute; top:${window.scrollY +
                            boundingRect.top}px; width:${
                            this.stickyData.initRect.width
                        }px`
                    );
                }
                this.stickyData.scrollY = window.scrollY;
                return;
            }
        },
        markPointClickHandler({ componentType, name } = {}) {
            if (componentType == 'series') {
                if (!this.disclosureList || !this.disclosureList.length) return;

                this.chartFixed = true;
                const ts = Math.floor(new Date(name).valueOf() / 1000);
                let offsetList = this.disclosureList.map(item => {
                    return {
                        datetime: item.datetime,
                        offset: Math.abs(ts - item.datetime),
                    };
                });
                offsetList.sort((a, b) => a.offset - b.offset);
                const datetime = offsetList[0].datetime;
                const ele = this.$refs.timeline.querySelector(
                    `[data-datetime="${datetime}"]`
                );
                const { top } = ele.getBoundingClientRect();
                window.scrollTo(0, top + window.scrollY);
            } else if (componentType == 'markPoint') {
                // 通过 aoi 和 product 对象赋值触发地图组件
                const refName = `image-${name}`;
                const key = Object.keys(this.$refs).find(
                    key => ~key.indexOf(refName)
                );
                const aoiId = this.$refs[key][0].$attrs['data-aoi-id'];
                this.aoi = this.realatedAoiList.find(item => item.id == aoiId);
                const productList = this.products.find(
                    item => item.id == aoiId
                );
                this.product = productList.items.find(
                    item => item.date_str == name
                );
                // this.$refs[key][0].clickHandler();
            }
        },
        disclosureHandler(jsonString) {
            DownloadDisclosure(jsonString);
        },
        async getRelatedAois() {
            try {
                const result = await this.REQUEST({
                    url: `v2/aoi/list?limit=-1&relation_type=stock&relation_value=${this.code}`,
                });
                this.realatedAoiList = result.data.items;
                this.products = null;
                for (let aoi of this.realatedAoiList) {
                    await this.getProducts(aoi.id, aoi.name);
                }
            } catch (e) {
                console.log(e);
            }
        },
        async getProducts(id, name) {
            const products = await this.REQUEST({
                url: `v2/aoi/product/list?aoi_id=${id}`,
            });
            if (!products.data.items) return;
            const myProducts = this.products || [];
            this.products = [
                ...myProducts,
                {
                    items: products.data.items.filter(item => item.built),
                    name,
                    id,
                },
            ];
        },
        async getStock() {
            if (this.stockLoading) return;
            this.stockLoading = true;
            try {
                const result = await this.REQUEST({
                    url: `v2/finance/stock/list?q=${this.code}&limit=1`,
                });
                this.stock = result.data.items[0];
                this.followed = this.stock.followed;
            } catch (e) {
                console.log(e);
            }
            setTimeout(() => {
                this.stockLoading = false;
            }, 1500);
        },
        async follow() {
            if (this.followLoading) return;
            this.followLoading = true;
            try {
                const result = await this.REQUEST({
                    url: `v2/finance/stock/follow?code=${this.code}`,
                    method: 'POST',
                    body: JSON.stringify({
                        code: this.code,
                        cancel: this.followed,
                    }),
                });
                this.followed = !this.followed;
            } catch (e) {
                console.log(e);
            }
            this.followLoading = false;
        },
        async getCompany() {
            if (this.companyLoading) return;
            this.companyLoading = true;
            try {
                const result = await this.REQUEST({
                    url: `v2/finance/company/list?code=${this.code}`,
                });
                this.company = result.data.items[0];
            } catch (e) {
                console.log(e);
                this.$router.push('/404');
            }
            this.companyLoading = false;
        },
        async getDisclosure() {
            if (this.disclosureLoading) return;
            this.disclosureLoading = true;
            try {
                const result = await this.REQUEST({
                    url: `v2/finance/stock/info/flow?code=${this.code}&limit=100`,
                });
                this.disclosureList = result.data.items;
            } catch (e) {
                console.log(e);
            }
            this.disclosureLoading = false;
        },
        async getDaily() {
            if (this.dailyLoading) return;
            this.dailyLoading = true;
            try {
                const result = await this.REQUEST({
                    url: `v2/finance/stock/trade/list?code=${this.code}&limit=100&size=100`,
                });
                this.dailyData = result.data.items;
            } catch (e) {
                console.log(e);
            }
            this.dailyLoading = false;
        },
        async getAois() {
            if (this.aoiLoading) return;
            this.aoiLoading = true;
            try {
                const result = await this.REQUEST({
                    url: 'v2/aoi/list',
                });
                this.aoiList = result.data.items;
            } catch (e) {
                console.log(e);
            }
            this.aoiLoading = false;
        },
        openDialog() {
            this.getAois();
            this.dialogShow = true;
        },
        createAoi() {
            this.$router.push({ path: '/aoi', query: { code: this.code } });
        },

        aoiChange(v) {
            this.aoiId = v;
        },
        async confirm() {
            if (this.aoiLoading) return;
            if (!this.aoiId) return (this.dialogShow = false);
            this.aoiLoading = true;
            try {
                const result = await this.REQUEST({
                    url: 'v2/aoi/relation',
                    method: 'POST',
                    body: JSON.stringify({
                        aoi_id: this.aoiId,
                        type: 'stock',
                        value: this.code,
                    }),
                });
                this.$message({
                    message: '关联成功',
                    type: 'success',
                });
                this.dialogShow = false;
                await this.getRelatedAois();
                this.initScorllRect();
            } catch (e) {
                console.log(e);
            }
            setTimeout(() => {
                this.initScorllRect();
            }, 500);
            this.aoiLoading = false;
        },
    },
};
</script>

<style lang="stylus" scoped>
h3
    font-weight 300
    margin-bottom 10px
    border-bottom 1px solid #252631
    padding 0 0 10px 0
    display flex
    justify-content space-between
    align-items center
    a
        margin-right 15px
        font-size 14px
        text-decoration underline
.stock-info
    width 700px
    margin-right 20px
.stock-detail-layout
    position relative
    display flex
    max-width 1000px
    margin 0 auto

    .box
        box-sizing border-box
        flex-grow 0
        flex-shrink 0
        // &:first-of-type
        //     width 24%
        // &:nth-of-type(2)
        //     width 48%
        // &:nth-of-type(3)
        //     width 24%
        //     margin-right 0
.timeline
    width 280px
.card
    position relative
.company-info
    height 150px
    overflow hidden
    margin-bottom 40px
    padding-bottom 25px
    position relative
    &.more
        height auto
    a
        color #fff
    .company
        overflow hidden
        line-height 2em
    .key
        font-weight bold
        color #3d59da
        display block
    .value
        color #767a8c
    .more-button
        text-align center
        position absolute
        width 100%
        left 0
        bottom 0
        background-image: linear-gradient(to bottom, transparent, #1e1f25);

.candlestick
    width 650px
    padding 20px 0
    position relative
    // &.on
    //     position fixed
    //     top 20px
    //     // left 200px
    //     // transform translateX(-50%)
    //     background #1e1f25
    //     box-shadow 0 0 3px 3px rgba(0,0,0,.8)
    //     z-index 2

.btns
    text-align right
.pointer
    cursor pointer
.products-container
    display flex
    width 100%
    overflow auto
    padding-top 20px
    margin-bottom 20px
    position relative
    .products-title
        position absolute
        top 0
        left 0
        font-size 16px
        color #3d59da
    dl
        margin 10px
    dt
        text-align center
    .img
        width 160px
.map
    padding-bottom 600px

.stock-refresh
    &:active
        transform scale(1.2)
.stock-loading
    animation: rotating 2s linear infinite;
</style>
